'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _language = require('../language');

var _Tooltip = require('../tooltip/Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconComponent = function (_PureComponent) {
    (0, _inherits3.default)(IconComponent, _PureComponent);

    function IconComponent(props) {
        (0, _classCallCheck3.default)(this, IconComponent);

        var _this = (0, _possibleConstructorReturn3.default)(this, (IconComponent.__proto__ || (0, _getPrototypeOf2.default)(IconComponent)).call(this, props));

        _this.state = {
            visible: props.visible
        };
        _this.dataTestID = 'icon-component';
        return _this;
    }

    (0, _createClass3.default)(IconComponent, [{
        key: 'openTooltip',
        value: function openTooltip() {
            this.setState({ visible: true });
        }
    }, {
        key: 'closeTooltip',
        value: function closeTooltip() {
            this.setState({ visible: false });
        }
    }, {
        key: 'renderIcon',
        value: function renderIcon() {
            var _props = this.props,
                iconCls = _props.iconCls,
                icon = _props.icon,
                iconType = _props.iconType,
                iconStyle = _props.iconStyle;

            if (icon) {
                return _react2.default.createElement(
                    'span',
                    {
                        style: (0, _assign2.default)({
                            width: 34,
                            textAlign: 'center',
                            fontSize: 15,
                            cursor: 'pointer'
                        }, iconStyle)
                    },
                    icon
                );
            }
            if (iconCls === 'percentage' || iconType) {
                return _react2.default.createElement(_Icon2.default, {
                    type: iconType || "percentage",
                    className: (0, _classnames2.default)('icon-field', iconCls),
                    style: (0, _assign2.default)({
                        width: 34,
                        textAlign: 'center',
                        fontSize: 15,
                        cursor: 'pointer'
                    }, iconStyle)
                });
            }
            return _react2.default.createElement('i', {
                className: (0, _classnames2.default)('icon-field', iconCls),
                style: (0, _assign2.default)({
                    width: 34,
                    textAlign: 'center',
                    fontSize: 15,
                    cursor: 'pointer'
                }, iconStyle)
            });
        }
    }, {
        key: 'getDataTestId',
        value: function getDataTestId() {
            var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'component';

            return this.props.dataTestID || this.dataTestID + '-' + prefix;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                position = _props2.position,
                onClick = _props2.onClick,
                iconLine = _props2.iconLine,
                tooltip = _props2.tooltip,
                style = _props2.style,
                trigger = _props2.trigger;
            var visible = this.state.visible;

            if (tooltip) {
                return _react2.default.createElement(
                    _Tooltip2.default,
                    {
                        title: _react2.default.createElement(_language.TextTranslate, { text: tooltip }),
                        placement: 'topLeft',
                        overlayClassName: 'overlay-tooltip-component',
                        trigger: trigger || "click",
                        visible: visible
                    },
                    _react2.default.createElement(
                        'div',
                        {
                            className: 'wrap-con-field',
                            style: (0, _assign2.default)({
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }, style),
                            onClick: onClick
                        },
                        (position === 'after' || position === 'right') && iconLine ? _react2.default.createElement('span', {
                            className: 'icon-field-line',
                            style: { width: 1, height: 16, borderLeft: '1px solid #ccc' }
                        }) : null,
                        this.renderIcon(),
                        (position === 'left' || position === 'before') && iconLine ? _react2.default.createElement('span', {
                            className: 'icon-field-line',
                            style: { width: 1, height: 16, borderLeft: '1px solid #ccc' }
                        }) : null
                    )
                );
            }
            return _react2.default.createElement(
                'div',
                {
                    'data-testid': this.getDataTestId(),
                    className: 'wrap-con-field',
                    style: (0, _assign2.default)({
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }, style),
                    onClick: onClick
                },
                (position === 'after' || position === 'right') && iconLine ? _react2.default.createElement('span', {
                    className: 'icon-field-line',
                    style: { width: 1, height: 16, borderLeft: '1px solid #ccc' }
                }) : null,
                this.renderIcon(),
                (position === 'left' || position === 'before') && iconLine ? _react2.default.createElement('span', {
                    className: 'icon-field-line',
                    style: { width: 1, height: 16, borderLeft: '1px solid #ccc' }
                }) : null
            );
        }
    }]);
    return IconComponent;
}(_react.PureComponent);

exports.default = IconComponent;


IconComponent.defaultProps = {
    iconCls: '',
    position: 'after',
    iconType: 'edit',
    iconLine: true
};